import type { PromoLinkClaimResult } from "@reactive-resume/dto";
import { promoLinkClaimResultSchema } from "@reactive-resume/dto";

import { axios } from "@/client/libs/axios";

export const claimPromoLink = async (code: string): Promise<PromoLinkClaimResult> => {
  const response = await axios.post<unknown>("/promo-links/claim", { code });

  return promoLinkClaimResultSchema.parse(response.data);
};
